<template>
  <div>
    <third-header-child
      :changeName="changeName"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
    />
    <third-body-child
      :newSection="newSection"
      :newItem="newItem"
      :listSections="listSections"
      :restaurant="restaurant"
      :setCurrentTab="setCurrentTab"
      :changeSectionTitle="changeSectionTitle"
      :changeSectionSubTitle="changeSectionSubTitle"
      :addItem="addItem"
      :newSubSection="newSubSection"
      :handleChangeShowSub="handleChangeShowSub"
      :disponibleItem="disponibleItem"
      :showItem="showItem"
      :changeItemObservation="changeItemObservation"
      :changeItemTitle="changeItemTitle"
      :changeItemPrice="changeItemPrice"
      :editCategorie="editCategorie"
      :deleteSection="deleteSection"
      :editSubCategorie="editSubCategorie"
      :deleteSubSection="deleteSubSection"
      :editItem="editItem"
      :currentCurrency="currentCurrency"
      :deleteItem="deleteItem"
      :currentLang="currentLang"
      :addToCart="addToCart"
    />

    <third-footer-child
      :changeName="changeName"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
      >


    </third-footer-child>
  </div>
</template>

<script>
import thirdHeader1 from "../headers/dropdown.vue";
import thirdBody1 from "../body/dropdown.vue";
import thirdFooter1 from "../footer/dropdown.vue";
export default {
  components: {
    "third-header-child": thirdHeader1,
    "third-body-child": thirdBody1,
    "third-footer-child": thirdFooter1
  },
  props: [
    "changeName",
    "currentLang",
    "newItem",
    "restaurant",
    "log",
    "functionCollapsed",
    "newSection",
    "listSections",
    "currentTab",
    "setCurrentTab",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "addItem",
    "newSubSection",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "changeItemObservation",
    "changeItemTitle",
    "changeItemPrice",
    "editCategorie",
    "deleteSection",
    "editSubCategorie",
    "deleteSubSection",
    "editItem",
    "currentCurrency",
    "deleteItem",
    "addToCart",
  ],
  data() {
    return {};
  },
  methods: {},
  watch: {}
};
</script>

<style></style>
